import { render } from "./TeacherInfoForm.vue?vue&type=template&id=5a01972a"
import script from "./TeacherInfoForm.vue?vue&type=script&lang=js"
export * from "./TeacherInfoForm.vue?vue&type=script&lang=js"

import "./TeacherInfoForm.vue?vue&type=style&index=0&id=5a01972a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__